import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmContactUsForHubs = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "csm-hub-contact-us" */ './csm-hub-variants'),
	),
});
